// ViewPack.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, CircularProgress, Paper } from '@mui/material';
import { supabase } from './supabase.js'; // Importation de Supabase
import DetailPanel from './DetailPanel'; // Import de DetailPanel
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../utils/theme';
import CssBaseline from '@mui/material/CssBaseline';


const ViewPack = () => {
  const { pack_id } = useParams(); // Récupération de pack_id depuis l'URL
  const navigate = useNavigate(); // Hook pour la navigation
  const [data, setData] = useState(null); // État pour stocker les données du pack
  const [loading, setLoading] = useState(true); // État pour gérer le chargement

  useEffect(() => {
    const fetchPackData = async () => {
      const { data: packData, error } = await supabase
        .from('pack')
        .select(`
          *,
          customers (
            *,
            pay (
              mois,
              annee,
              salaire
            ),
            tax (
              revenu,
              annee_impots,
              situation,
              domiciliation,
              parts,
              autre_doc,
              pdf
            ),
            identity (
              id,
              type_doc,
              qualite,
              noiretblanc,
              pdf,
              birthdate,
              expiry_date,
              race,
              country,
              "4_bords_visibles",
              civilite,
              autre_doc
            )
          )
        `) // Requête correcte pour charger les données nécessaires
        .eq('pack_id', pack_id)
        .eq('statut', 'Actif')
        .single();

      if (error) {
        if (process.env.NODE_ENV !== 'production') console.error('Erreur lors du chargement des données :', error);
        setLoading(false);
      } else {
        const { data: banqueData } = await supabase.from('banque').select('Code_Banque, Banque');
        const banqueMap = new Map((banqueData || []).map((b) => [b.Code_Banque, b.Banque]));

        packData.customers = packData.customers.map((customer) => {
          customer.nom_banque = banqueMap.get(customer?.code_banque) ?? 'N/A';
          return customer;
        });
        
        setData(packData); // Stockage des données du pack
        setLoading(false);
      }
    };

    fetchPackData(); // Appel de la fonction pour charger les données
  }, [pack_id]); // Dépendance sur pack_id

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' height='100vh'>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return <Typography variant='h6'>Aucune donnée trouvée</Typography>;
  }

  // Remplacez 'Actif' par 'Disponible'
  const statut = data.statut === 'Actif' ? 'Disponible' : data.statut;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <Box>
    <AppBar position="static">
  <Toolbar sx={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    padding: '8px'
  }}>
    <Button 
      color="warning" 
      onClick={() => navigate('/')}
      sx={{ 
        flexShrink: 0, // Empêche le bouton de rétrécir
        mr: { xs: 1, sm: 2 } // Marge à droite, plus grande sur desktop
      }}
    >
      Retour
    </Button>
    <Typography 
      variant="h6" 
      sx={{ 
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        whiteSpace: 'nowrap', // Empêche le texte de passer à la ligne
        overflow: 'hidden',
        textOverflow: 'ellipsis', // Ajoute des points de suspension si le texte est trop long
        maxWidth: { xs: 'calc(100% - 240px)', sm: 'calc(100% - 300px)' } // Ajuste la largeur maximale
      }}
    >
      Dossier {data.pack_id}
    </Typography>
  </Toolbar>
</AppBar>
      <Paper elevation={3} sx={{ padding: 2, margin: 2, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Statut: {statut} {/* Affichage du statut */}
        </Typography>
          <Typography variant="h6" sx={{ mb: 2 }}>
          Prix: {data.price ? data.price.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) : 'N/A'} {/* Affichage du prix */}
  </Typography>
        <DetailPanel row={{ original: data }} />
      </Paper>
    </Box>
    </ThemeProvider>
  );
};

export default ViewPack;
